import { FC, SVGProps } from 'react';

export const TaskNumbersIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.25879 5.81592H11.9338" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.06641 5.81611L4.59141 6.34111L6.16641 4.76611" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.25879 10.7158H11.9338" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.06641 10.716L4.59141 11.241L6.16641 9.66602" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.9 15H10.1C13.6 15 15 13.6 15 10.1V5.9C15 2.4 13.6 1 10.1 1H5.9C2.4 1 1 2.4 1 5.9V10.1C1 13.6 2.4 15 5.9 15Z"
      stroke="#141414"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
